var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"main-hero",attrs:{"src":require("@/assets/nuvolos-layer-v13.svg"),"alt":"Nuvolos hero"}})
}
var staticRenderFns = []

export { render, staticRenderFns }